/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
// Plain YouTube embed with native controls (play/pause/volume/fullscreen —
// all YouTube's own UI, nothing custom-built). The IFrame API is loaded
// ONLY to listen for onStateChange so the matching sidebar card can swap
// its play/pause icon to reflect what's actually happening — it never
// rebuilds or replaces YouTube's own controls.
function deskLoadYouTubeApi() {
  if (window.YT && window.YT.Player) {
    return Promise.resolve();
  }
  if (!window.__deskYtApiPromise) {
    window.__deskYtApiPromise = new Promise(function (resolve) {
      var previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof previous === 'function') previous();
        resolve();
      };
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    });
  }
  return window.__deskYtApiPromise;
}

function deskPlayVideo($panel, $section) {
  var el = $panel[0];
  if (el.classList.contains('is-playing')) return;

  var videoId = el.getAttribute('data-youtube-id');
  var index = el.getAttribute('data-index');
  if (!videoId) return;

  var iframe = document.createElement('iframe');
  iframe.src =
    'https://www.youtube.com/embed/' +
    videoId +
    '?autoplay=1&playsinline=1&enablejsapi=1&origin=' +
    window.location.origin;
  iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('title', el.getAttribute('data-title') || '');

  el.appendChild(iframe);
  el.classList.add('is-playing');

  // Attach the API to the iframe we already created (enablejsapi=1) instead
  // of letting YT.Player build its own — it reuses this exact iframe and
  // its native controls, only adding the ability to listen for events.
  deskLoadYouTubeApi().then(function () {
    var $card = $section.find('.video-showcase__card[data-index="' + index + '"]');
    el.__deskYtPlayer = new YT.Player(iframe, {
      events: {
        onStateChange: function (e) {
          var isPlaying = e.data === YT.PlayerState.PLAYING;
          $card.toggleClass('is-playing', isPlaying);
        }
      }
    });
  });
}

function deskStopVideo($panel, $section) {
  var el = $panel[0];
  var iframe = el.querySelector('iframe');
  if (iframe) iframe.remove();
  el.classList.remove('is-playing');
  el.__deskYtPlayer = null;

  var index = el.getAttribute('data-index');
  $section.find('.video-showcase__card[data-index="' + index + '"]').removeClass('is-playing');
}

// The block's overall height is dictated by the video player itself (its
// own aspect-ratio height) — not by the wrapper, and not by the card list.
// .video-showcase__body and .video-showcase__list are both pinned to the
// active player's rendered height; the list scrolls internally
// (overflow-y) whenever its cards don't fit. Below the tablet/mobile
// breakpoint the layout stacks vertically, so the pinned heights are
// cleared and everything just sizes to its own content.
function deskSyncVideoShowcaseHeight($section) {
  var $body = $section.find('.video-showcase__body').first();
  var $list = $section.find('.video-showcase__list').first();
  if (!$body.length || !$list.length) return;

  if (window.matchMedia('(max-width: 1279px)').matches) {
    $body.css('height', '');
    $list.css('height', '');
    return;
  }

  var $player = $section.find('.video-showcase__player.active').first();
  if (!$player.length) return;

  var height = $player[0].getBoundingClientRect().height;
  $body.css('height', height + 'px');
  $list.css('height', height + 'px');

  deskSyncVideoShowcaseScrollbar($section);
}

function deskSyncVideoShowcaseScrollbar($section) {
  var $wrap = $section.find('.video-showcase__list-wrap').first();
  var $list = $section.find('.video-showcase__list').first();
  var $bar = $section.find('.video-showcase__scrollbar').first();
  var $thumb = $section.find('.video-showcase__scrollbar-thumb').first();
  if (!$wrap.length || !$list.length || !$bar.length || !$thumb.length) return;

  var list = $list[0];
  var canScroll = list.scrollHeight > list.clientHeight + 1;

  $bar.toggleClass('is-visible', canScroll);
  if (!canScroll) return;

  var trackHeight = $bar[0].getBoundingClientRect().height;
  if (!trackHeight) return;

  var thumbHeight = Math.max(24, trackHeight * (list.clientHeight / list.scrollHeight));
  var maxScroll = list.scrollHeight - list.clientHeight;
  var maxThumbTop = trackHeight - thumbHeight;
  var thumbTop = maxScroll > 0 ? (list.scrollTop / maxScroll) * maxThumbTop : 0;

  $thumb.css({ height: thumbHeight + 'px', top: thumbTop + 'px' });
}

$(function () {
  var $deskVideoShowcaseSections = [];

  $.each(window.DeskVideoShowcase || {}, function (sectionId) {
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;

    var $section = $(section);
    $deskVideoShowcaseSections.push($section);

    $section.on('click', '.video-showcase__poster-btn', function () {
      var $panel = $(this).closest('.video-showcase__player');
      deskPlayVideo($panel, $section);
    });

    $section.on('click', '.video-showcase__card', function () {
      var index = $(this).data('index');

      $section.find('.video-showcase__card').removeClass('active');
      $(this).addClass('active');

      var $panels = $section.find('.video-showcase__player');

      // Stop and unload any panel that isn't the one being switched to, so
      // audio never keeps playing in the background on a hidden panel.
      $panels.not('[data-index="' + index + '"]').each(function () {
        var $p = $(this);
        deskStopVideo($p, $section);
        $p.removeClass('active');
      });

      var $panel = $panels.filter('[data-index="' + index + '"]').addClass('active');
      deskPlayVideo($panel, $section);
      deskSyncVideoShowcaseHeight($section);
    });

    $section.find('.video-showcase__list').on('scroll', function () {
      deskSyncVideoShowcaseScrollbar($section);
    });


    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(function () {
        deskSyncVideoShowcaseHeight($section);
      });
      observer.observe(section);
    }

    deskSyncVideoShowcaseHeight($section);
  });

  $(window).on('resize', function () {
    $.each($deskVideoShowcaseSections, function () {
      deskSyncVideoShowcaseHeight(this);
    });
  });
});

(function () {
  function wrapGroups() {
    var groups = {};

    document.querySelectorAll('[data-mobile-swap-group]').forEach(function (el) {
      // .trim() apsaugo nuo atvejo, kai atributo reikšmėje yra tarpų
      var key = el.dataset.mobileSwapGroup.trim();
      if (!groups[key]) groups[key] = [];
      groups[key].push(el);
    });

    Object.keys(groups).forEach(function (key) {
      var pair = groups[key];

      if (pair.length !== 2) {
        // ne pora — tik pažymim, wrap'o nekuriam
        pair.forEach(function (el) { el.classList.add('swap-ready'); });
        return;
      }

      var a = pair[0];
      var b = pair[1];

      if (a.dataset.wrapped) return; // jau apwrapinta anksčiau

      var wrapper = document.createElement('div');
      wrapper.classList.add('mobile-swap-wrap');
      wrapper.dataset.mobileSwapGroup = key;

      a.parentNode.insertBefore(wrapper, a);
      wrapper.appendChild(a);
      wrapper.appendChild(b);

      a.dataset.wrapped = 'true';
      b.dataset.wrapped = 'true';

      a.classList.add('swap-ready', 'mobile-swap-first');
      b.classList.add('swap-ready', 'mobile-swap-second');
    });
  }

  function init() {
    wrapGroups();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();